import { useCallback } from 'react';
import useMountedState from './use-mounted-state';

const _default: () => <T>(promise: Promise<T>) => Promise<T> = () => {
	const isMounted = useMountedState();

	return useCallback(
		<T>(promise: Promise<T>) =>
			new Promise<T>((resolve, reject) => {
				promise
					.then((result) => {
						if (isMounted()) {
							resolve(result);
						}
					})
					.catch((error) => {
						if (isMounted()) {
							reject(error);
						}
					});
			}),
		[isMounted],
	);
};
export default _default;
